import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import { API } from "aws-amplify";
import Nav from "react-bootstrap/Nav";
import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import config from '../config';
import "./Home.css";

export default function Home() {
  const { userProfile, isAuthenticated, userHasAuthenticated, isAdmin, setUserProfile } = useAppContext();
  const history = useHistory();
  const [isLoaded, setIsLoaded] = useState(false);
  const [member, setMember] = useState(null);
  const [memType, setMemType] = useState("0");
  const [memberTypeLabel, setMemberTypeLabel] = useState("");
  const [hasUserProfile, setHasUserProfile] = useState(false);

 useEffect(() => {
    console.log('useEffect home(top)...');
    const onPreLoad = async () => {
      console.log(userProfile);
      if (userProfile)
        setHasUserProfile(true);
//      const isEmpty = (userProfile && Object.keys(userProfile).length === 0 && userProfile.constructor === Object);
//      console.log(isEmpty);
      if(false) {
        const info = await Auth.currentUserInfo();
        console.log('get UserInfo on home:');
        console.log(info);
        setUserProfile(info);
      }

    };
    onPreLoad();

    const onLoad = async () => {
      try {
        const m = await loadMember();
        console.log(m);
        console.log(m.memClass);
        if (m.memClass != 1) {
          await Auth.signOut();
          userHasAuthenticated(false);
        }
        setMemType(m.memType);
          setMemberTypeLabel(m.memType == 1 || m.memType == 2 || m.memType == 3 || m.memType == 8 ? '正会員' : (m.memType == 4 || m.memType == 5 || m.memType == 6 || m.memType == 7 || m.memType == 10 ? '准会員' : (m.memType == 14 || m.memType == 15 || m.memType == 16 || m.memType == 17 ? '学生会員' : '会員')));
      } catch (e) {
        console.log('caught loading on home');
        onError(e);
      }
    };
    console.log('load page');
    console.log(isAuthenticated);
    console.log(userProfile);
    console.log(isAdmin);
    if (isAdmin) { history.push('/admin'); return;}
    onLoad();
    setIsLoaded(true);
  },[]);


  function loadMember() {
    console.log('path : ' + `/members/${userProfile.attributes.preferred_username}`);
    return API.get("sakurajima", `/members/${userProfile.attributes.preferred_username}`); 
  }

    return isAuthenticated && isLoaded && (
    <div className="Home">
      <h1 id="page_title">{memberTypeLabel}　マイページ</h1>
      <div className="container">
        <div id="sub_page">
          <div id="mypage" className="top">
              <section>
                <div className="inner">
                  <ul>
                    <li>
            <Nav.Link href={`/editMembers/${userProfile.attributes.preferred_username}`} style={{ "margin-bottom": "2.5rem" }}>会員情報確認・編集</Nav.Link>
                    </li>
            { memberTypeLabel == '准会員' ? (
                    <li>
                    <Nav.Link className={ memType == 7 ? 'homeMenuDisabled' : (config.mail.bcc == 'test-apply@rinspo.jp' ? '' : '')} href={`/editMembers/${userProfile.attributes.preferred_username}?amd=transfer`} style={ { "opacity": config.mail.bcc == 'test-apply@rinspo.jp' ? "100%" : "100%" } }>正会員への申請</Nav.Link>
                      <p>※正会員への申請は毎年2月1日～2月末日と8月1日～8月末日の2期となります。</p>
                      <br/>
                    </li>
	    ) : <></> }

                    <li>
                      <Nav.Link className={ config.mail.bcc == 'test-apply@rinspo.jp' ? '' : '' } href={`/mypage?mtl=${memberTypeLabel}`} style={ { "opacity": config.mail.bcc == 'test-apply@rinspo.jp' ? "100%" : "100%" } }>年会費納入状況確認</Nav.Link>
                      {/* <p className="homeCautions">年会費納入状況確認は準備中です</p> */}
                      <br/>
                    </li>
                    <li>
            <Nav.Link style={ { "display" : config.mail.bcc == "test-apply@rinspo.jp" ? "block" :  "block"} } href={`https://www.rinspo.jp/education_training/index.html`} target="_blank">スポーツ医学 現場見学・研修マッチングプログラム</Nav.Link>
                        <p style={ { "display" : config.mail.bcc == "test-apply@rinspo.jp" ? "block" :  "block"} }>「スポーツ医学 現場見学・研修マッチングプログラム」にアクセスする際には、</p>
                        <p>下記のユーザー名とパスワードが必要になります。</p>
                        <p style={ { "display" : config.mail.bcc == "test-apply@rinspo.jp" ? "block" :  "block"} }>ユーザー名：<span className="label-ipa">rinspo</span>　パスワード：<span className="label-ipa">rnsp</span></p>
                    </li>
                    <li>
            <Nav.Link style={ { "display" : config.mail.bcc == "test-apply@rinspo.jp" ? "block" :  "block"} } href={`https://www.rinspo.jp/journal/abstract/index.html`} target="_blank">学会誌抄録号</Nav.Link>
                        <p style={ { "display" : config.mail.bcc == "test-apply@rinspo.jp" ? "block" :  "block"} }>「学会誌抄録号」にアクセスする際には、</p>
                        <p>下記のユーザー名とパスワードが必要になります。</p>
                        <p style={ { "display" : config.mail.bcc == "test-apply@rinspo.jp" ? "block" :  "block"} }>ユーザー名：<span className="label-ipa">rinspo</span>　パスワード：<span className="label-ipa">rnsp</span></p>
                    </li>
                  </ul>
                </div>
              </section>
          </div>
        </div>
      </div>
    </div>
  );
}
